import SphConstants from 'sg-sph-constants';
import CommonConstants from 'sg-common-constants';

const getCoverLevelName = (renewal) => {
    let coverName;
    const { coverLevel } = renewal;
    if (renewal.renewalUpgradeData && renewal.renewalUpgradeData.isPlusP1) {
        if (coverLevel === SphConstants.COVER_TERMS.HOME_INSURANCE
            || coverLevel.includes(SphConstants.COVER_TERMS.HOME_INSURANCE)
            || coverLevel === SphConstants.COVERAGES_CODES.CoverLevelPlus) {
            coverName = CommonConstants.COVER_LEVEL_NAMES.PLUS;
        } else if (coverLevel === SphConstants.COVER_TERMS.ESSENTIAL
            || coverLevel.includes(SphConstants.COVER_TERMS.ESSENTIAL)
            || coverLevel === SphConstants.COVERAGES_CODES.CoverLevelSelect || coverLevel === SphConstants.COVERAGES_CODES.CoverLevelSelectAd) {
            coverName = CommonConstants.COVER_LEVEL_NAMES.SELECT;
        } else {
            coverName = coverLevel;
        }
    } else {
        coverName = coverLevel;
    }
    return coverName;
};

const isSagaPlus = (renewal) => {
    return getCoverLevelName(renewal.renewalDetails) === CommonConstants.COVER_LEVEL_NAMES.PLUS;
};

const isUpgrading = (renewal) => {
    return !!renewal.isUpgrading;
};

const isTravelProduct = (modelVM) => {
    return modelVM.renewalDetails.productCode && modelVM.renewalDetails.productCode.value === CommonConstants.TRAVEL_PRODUCT_CODE;
};

const isHomeProduct = (modelVM) => {
    return modelVM.renewalDetails.productCode && modelVM.renewalDetails.productCode.value === CommonConstants.HOME_PRODUCT_CODE;
};

export default {
    getCoverLevelName,
    isSagaPlus,
    isUpgrading,
    isTravelProduct,
    isHomeProduct
};
